export enum ContractedEmployeeGridField {
  employeeName = "employeeName",
  employeeType = "employeeType",
  year = "year",
  isVisible = "isVisible",
  summary = "summary",
}
